import React from "react";
import { Button } from "antd";
import { DataTable } from "./DataTable";
import { YhBox } from "@/components/YhBox";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { useStockStatisticModel } from "../stockStatisticModel";
import useGlobalModel from "@/model/globalModel";
import zh_CN from "@/locale/zh-CN";
import en_US from "@/locale/en-US";

export const DataBox = () => {
    let LanguageArr: any = {
        "zh-CN": zh_CN,
        "en-US": en_US
    }
    const { setLocale } = useGlobalModel()
    const Locale = setLocale(LanguageArr)

    const { drawerVisible, descTotal, listExport } = useStockStatisticModel();
    const desc: IDescription[] = [
        {
            label: Locale["Qty in Stock"],//"库存总数量",
            value: descTotal.total,
            color: DescriptionColorEnum.green
        },
        {
            label: Locale["Species Number in Stock"],//"库存种类",
            value: descTotal.type,
            color: DescriptionColorEnum.red
        },
        {
            label: Locale["Average Inventory Cost"],//"库存成本(平均)",
            value: descTotal.averageAmount,
            color: DescriptionColorEnum.red
        },
        {
            label: Locale["Latest Inventory Cost"],//"库存成本(最近)",
            value: descTotal.latestAmountTotal,
            color: DescriptionColorEnum.red
        }
    ]
    const onExport = () => {
        listExport().then()
    }
    const action = <Button
        className="mr-5"
        type="link"
        shape="round"
        onClick={onExport}
    >导出</Button>
    return (
        <YhBox title={action} descriptions={desc}>
            <DataTable />
        </YhBox>
    )
}